import { Popover } from "antd";
import React from "react";

import FindingVariablesTable from "ac-components/FindingVariablesTable";

import { InfoIcon } from "../Icons";
import "./FindingVariablesTablePopover.less";

interface FindingVariablesTablePopoverProps {
  fields: string[];
  fieldsDescription: Record<string, string>;
}
const FindingVariablesTablePopover: React.FC<
  FindingVariablesTablePopoverProps
> = ({ fields, fieldsDescription }) => {
  return (
    <Popover
      overlayClassName="no-padding-popover"
      content={
        <div style={{ maxHeight: 500, overflowY: "auto", width: 500 }}>
          <FindingVariablesTable
            fields={fields}
            fieldsDescription={fieldsDescription}
          />
        </div>
      }
      placement="right"
    >
      <InfoIcon className="m-l-xs" />
    </Popover>
  );
};
export default FindingVariablesTablePopover;
